module.exports = __webpack_public_path__ + "img/SA Cover page logo.f90034ee.svg";